module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/large.11fc1afae97ec97b3b46.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow-bokeh/large.jpg
// module id = rIl/
// module chunks = 1